module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Dress-8ad8d0a41c664d60ac726f96700996fc5fb421ea6cf41ca1dea95e1c83be2600.svg";